/**
 * Main entry point for standalone/domain mode
 *
 * Mode detection:
 * - Subdomain mode (*.restohub.io): resolves slug → restaurantId, then renders app
 * - Development mode (localhost ports): uses port-based config
 * - Embedded mode: uses env variables
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './store'
import { Toaster } from '@/components/ui'
import { ThemeProvider } from '@/context/ThemeContext'

import App from './App.tsx'
import { SlugResolver } from '@/components/SlugResolver'
import { detectSubdomainSlug } from '@/config/environment'
import './styles/globals.css'

const slug = detectSubdomainSlug()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        {slug ? (
          <SlugResolver slug={slug}>
            <App />
            <Toaster richColors position="top-right" />
          </SlugResolver>
        ) : (
          <>
            <App />
            <Toaster richColors position="top-right" />
          </>
        )}
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
)
